import * as React from 'react';

import Counter from 'components/atoms/Counter';
import Icon from 'components/atoms/Icon';

export type CalendarDayPropsType = {
	modifier?: string;
	completed?: boolean;
	abbr: string;
	day?: string;
	date?: string;
	counter?: {
		count: number;
		modifier: string;
	};
	state?: string;
	progressState?: string;
	end?: boolean;
	itemsCheckable: boolean;
	isPast?: boolean;
	handleClick: Function;
	dayNumber?: number | null;
	hasAlreadyStartedChecking: boolean;
};

export default class CalendarDay extends React.Component<CalendarDayPropsType> {
	get className(): string {
		const {
			modifier,
			end,
			state,
			progressState,
			counter,
			isPast,
			itemsCheckable,
			hasAlreadyStartedChecking,
		} = this.props;

		const classNames: Array<string> = ['m-calendar-day'];
		if (modifier) {
			classNames.push(`m-calendar-day--${modifier}`);
		}
		if (modifier !== 'disabled') {
			classNames.push('js-m-calendar-day');
		}
		if (state) {
			classNames.push(`state-m-calendar-day--${state}`);
		}
		if (progressState) {
			classNames.push(`state-m-calendar-day--${progressState}`);
		}
		if (end) {
			classNames.push('m-calendar-day--end');
		}
		if (counter && counter.count > 0) {
			classNames.push(`state-m-calendar-day--counter`);
		}
		if (isPast && !itemsCheckable && hasAlreadyStartedChecking) {
			classNames.push(`state-m-calendar-day--todo-past`);
		}

		return classNames.join(' ');
	}

	public render() {
		const { counter, completed, abbr, day, date, dayNumber, handleClick, itemsCheckable } = this.props;

		return (
			<div onClick={handleClick.bind(this, dayNumber)} className={this.className}>
				<span className="m-calendar-day__marker">
					{counter && itemsCheckable && <Counter count={counter.count} modifier={counter.modifier} />}

					{completed && <Icon iconName="completed2" />}
				</span>
				<div className="m-calendar-day__abbr">{abbr}</div>
				<div className="m-calendar-day__text">
					{day} <span className="m-calendar-day__date">{date}</span>
				</div>
			</div>
		);
	}
}
